import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@app/hooks"
import { selectCurrentLocation, selectLastLocation } from "@shared/location/selectors"
import { updateCityFilter } from "@shared/filter/filterSlice"

// Город в шапке и фильтр ленты должны совпадать всегда — как бы город ни поменялся:
// выбор в шапке, определение по IP или дефолт при первом визите.
export function LocationFilterSync() {
  const dispatch = useAppDispatch()
  const current = useAppSelector(selectCurrentLocation)
  const last = useAppSelector(selectLastLocation)
  const city = (current ?? last)?.city
  const filterCity = useAppSelector(state => state.filter.city)

  useEffect(() => {
    const target = city && city !== "Вся Россия" ? city : undefined
    if (target !== filterCity) dispatch(updateCityFilter(target))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city])
  return null
}
export default LocationFilterSync
